export const PAGE_CONFIG = {
  personal: {
    path: '/personalDetail',
    type: 'personal',
  },
  enterprise: {
    path: '/enterpriseDetail',
    type: 'enterprise',
  },
}
